import {
    createFeatureReducer,
    entityListReducer,
    FeatureActionReducer,
    PayloadAction
} from '../../store/store.utils';
import { UtilState } from './utils.state';
import { Application } from '../../../../common/models/application.interface';
import { initialUtilState } from './utils.state';

abstract class UtilActionReducer extends FeatureActionReducer<UtilState> {
    protected constructor(name: string) {
        super('Util', name);
    }
}

export class SetDownloadInfo extends UtilActionReducer {
    constructor(public readonly payload) {
        super('Add Download URL');
    }
    reduce(state: UtilState): UtilState {
        return {
            ...state,
            ui: {
                ...state.ui,
                downloadInfo: {
                    fileName: this.payload.fileName,
                    url: this.payload.url
                }
            }
        };
    }
}

export class GetApplicationListRequest extends UtilActionReducer {
    constructor() {
        super('Appication List Request');
    }

    reduce(state: UtilState): UtilState {
        return state;
    }
}

export class GetApplicationListRequestSuccess
    extends UtilActionReducer
    implements PayloadAction<Application[]> {
    constructor(public readonly payload: Application[]) {
        super('Application List Success');
    }

    reduce(state: UtilState): UtilState {
        return {
            ...state,
            data: {
                application: entityListReducer<string, Application>(
                    state.data.application,
                    this.payload,
                    'access_key'
                )
            }
        };
    }
}

const typedReducer = createFeatureReducer(UtilActionReducer, initialUtilState);
export function utilReducer(state: any, action: any) {
    return typedReducer(state, action);
}
